import { useState, useEffect } from "react"
import Sidebar from "../components/Sidebar";
import Notification from "../components/Notification";
import Header from "../components/Header";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faWifi, faPlus, faXmark, faCircleNotch, faBolt } from '@fortawesome/free-solid-svg-icons'
import { faEye, faEyeSlash } from '@fortawesome/free-regular-svg-icons'
import SignalCard from "../components/SignalCard";
import { formatCurrency, getCurrencySymbol, getRate } from '../utils/currencyUtils';
import { useUser } from "../utils/UserContext";
import Modal from 'react-modal';
import { toast } from 'react-hot-toast';
import { Link } from 'react-router-dom'

function Signal() {
  const { user } = useUser();
  const [modalIsOpen, setIsOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [disable, setDisable] = useState(true);
  const [signal_name, setSignal_name] = useState();
  const [amount, setAmount] = useState();

  useEffect(() => {
    if(signal_name && amount){
      setDisable(false);
    }else{
      setDisable(true);
    }
  }, [signal_name, amount]);

  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };
  const [rate, setRate] = useState(1);
  const currencyCode = user?.currency;
  useEffect(() => {
    let isMounted = true;
    const fetchRate = async () => {
      const r = await getRate(currencyCode);
      if (isMounted) setRate(r);
    };
    fetchRate();
    return () => { isMounted = false; };
  }, [currencyCode]);
  const [notificationbar, setNotificationbar] = useState(false);
  const toggleNotification = () => {
    setNotificationbar(!notificationbar);
  };
  const [settingsBar, setSettingsBar] = useState(false);
  const toggleSettingsBar = () => {
    setSettingsBar(!settingsBar);
  };
  const [see, setSee] = useState(true);
  const usdbal = user?.signal_balance;
  const [signals, setSignals] = useState([]);
  const [mysignal, setMysignal] = useState();

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}controller/fetch.controller.php`, {
      credentials: "include",
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ fetchSignal: true })
    })
    .then(response => response.json())
    .then(data => {
      if (data.status === "success") {
        setSignals(data.signals);
        const mySignal = signals.find(signal => signal.signal_id === user.signal_id);
        setMysignal(mySignal);
      }
    })
    .catch(err => {
      console.log(err);
        console.error('Error fetching signals!')
    })
  }, [user]);

  const AddSignal = () =>{
    setLoading(true);
    fetch(`${process.env.REACT_APP_API_URL}controller/signal.controller.php`, {
      credentials: "include",
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ btn_addsignal: true, signal_name : signal_name, amount : amount})
    })
    .then(response => response.json())
    .then(data => {
      if (data.status === "success") {
        toast.success(data.result);
        setTimeout(() => {
            window.location.href = "signal";
          }, 2000);
      }else{
        toast.error(data.message);
      }
      setLoading(false);
    })
    .catch(err => {
      console.error(err)
      setLoading(false);
    })
  }

  return (
    <div className="container-fluid">
      <div className="row g-0">
        <Notification isOpen={notificationbar} toggleNotification={toggleNotification}/>
        <Sidebar title="Signals" isOpen={isSidebarOpen} toggleSidebar={toggleSidebar} toggleSettingsBar={toggleSettingsBar} settingsBar={settingsBar}/>
        <div className="col ps-md-2 mainBar">
          <Header title="Signals" icon={<FontAwesomeIcon icon={faWifi} style={{fontSize: '16px'}} />} toggleSidebar={toggleSidebar} toggleNotification={toggleNotification} toggleSettingsBar={toggleSettingsBar}/>
          <main>
            <div className="row">
              <div className="col-12">
                <div className="row">
                    <div className="col-lg-6">
                        <div className="mycard mt-2" style={{minHeight: '160px'}}>
                            <div className="d-md-flex justify-content-between mb-5">
                                <div>
                                    <div className="d-flex justify-content-between align-items-center">
                                        <p className="text-secondary fw-bold mb-0">Total Signal Balance: <FontAwesomeIcon icon={(see === true)?faEye:faEyeSlash} className="ms-2" style={{fontSize: '14px'}} onClick={() => {
                                        setSee(see === true ? false : true);
                                        }}/></p>
                                    </div>
                                    <h2 className="fs-4 fw-bold">{see ? `${getCurrencySymbol(user?.currency)}${formatCurrency(usdbal * rate)}` : '******'}</h2>
                                </div>
                                <Link to="/deposit" state={{route: 'signal'}} className="noLink">
                                    <div className="px-3 py-2 d-flex align-items-center rounded-2" style={{backgroundColor: '#ffffff06',textDecoration:'none'}}>
                                      <FontAwesomeIcon className="text-prime lh-1 me-2" icon={faBolt} style={{fontSize:'14px'}} />
                                      <p className="mb-0 fw-semibold text-prime" style={{fontSize: '14px'}}>Deposit</p>
                                    </div>
                                </Link>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-6">
                        <div className="mycard mt-2" style={{minHeight: '160px'}}>
                            <div className="d-flex align-items-center justify-content-between mb-3">
                              <h6 className="text-secondary fw-bold mb-0">Signal strength</h6>
                              <h6 className={`fw-bold mb-0 ${user?.signals > 70 ? 'text-success' : user?.signals > 30 ? 'text-warning' : 'text-danger'}`}>
                                {user?.signals}%
                              </h6>
                            </div>
                            <div className="d-flex justify-content-between mb-2">
                            {Array(20)
                              .fill()
                              .map((_, i) => {
                                const isActive = i < user?.signals / 5;
                                let activeColor, inactiveColor;
                                if (user?.signals > 70) {
                                  activeColor = "rgb(40, 167, 69)";     // Green
                                  inactiveColor = "rgba(40, 167, 69, 0.5)";
                                } else if (user?.signals > 30) {
                                  activeColor = "rgb(255, 193, 7)";     // Yellow
                                  inactiveColor = "rgba(255, 193, 7, 0.5)";
                                } else {
                                  activeColor = "rgb(255, 51, 68)";     // Red
                                  inactiveColor = "rgba(255, 51, 68, 0.5)";
                                }
                                return (
                                  <div
                                    key={i}
                                    style={{
                                      width: "4%",
                                      height: "12px",
                                      borderRadius: "2px",
                                      backgroundColor: isActive ? activeColor : inactiveColor,
                                      transition: "background-color 0.3s ease-in-out"
                                    }}
                                  ></div>
                                );
                              })}
                            </div>
                            <div className="d-flex align-items-center justify-content-between mt-5">
                                <p className="text-secondary fw-bold mb-0">{mysignal?mysignal.signal_name:'No active signal'}</p>
                                <p className="text-prime mb-0 fw-bold" style={{cursor: 'pointer'}}>{getCurrencySymbol(user?.currency)}{formatCurrency(mysignal?mysignal.amount * rate:0)}</p>
                            </div>
                        </div>
                    </div>
                </div>
              </div>
              <div className="col-12">
                <div className="d-flex align-items-center justify-content-between">
                  <h5 className="mb-4 fw-bold text-white mt-5 ms-2">Signals</h5>
                  {user?.user_type === "adminface" && (
                    <div className="myBtn d-inline-block bg-prime px-3" style={{fontSize: '14px'}} onClick={() => setIsOpen(true)}><FontAwesomeIcon icon={faPlus} style={{fontSize: '12px'}} /> Add Signal</div>
                  )}
                </div>
                <div className="row">
                  {signals.map((signal) => (
                    <div className="col-xxl-3 col-lg-4 col-6 col-12">
                        <SignalCard key={signal.id} signal_id={signal.signal_id} name={signal.signal_name} price={signal.amount}/>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </main>
        </div>
        <Modal
            isOpen={modalIsOpen}
            onRequestClose={() => setIsOpen(false)}
            shouldCloseOnOverlayClick={true} 
            closeTimeoutMS={100}
            className="shortmode"
        >
            <div className="d-flex align-items-center justify-content-between">
                <p className="mb-0 fw-bold text-white" style={{fontSize: '16px'}}>
                Add subscription plan</p>
                <FontAwesomeIcon className="py-1 px-2 rounded-3" icon={faXmark} style={{fontSize: '15px', backgroundColor: 'rgba(255, 255, 255, 0.1)', cursor: 'pointer'}} onClick={() => setIsOpen(false)} />
            </div>
            <label className="fw-semibold mb-1 mt-2" style={{fontSize: '14px'}}>Signal Name:</label>
            <div className="form-control py-2">
                <input 
                  type="text"
                  placeholder="RoboForex"
                  className="inputNone"
                  value={signal_name}
                  onChange={(e) => setSignal_name(e.target.value)}
                />
            </div>
            <label className="fw-semibold mt-2 mb-1" style={{fontSize: '14px'}}>Amount:</label>
            <div className={`d-flex align-items-between form-control justify-content-between py-1 pe-1 `}>
                <input 
                  type="number"
                  placeholder="1000"
                  className="inputNone"
                  value={amount}
                  onChange={(e) => setAmount(e.target.value)}
                />
                <div
                  className="fw-bold text-white d-flex align-items-center"
                  style={{
                    backgroundColor: 'rgb(30, 33, 36)',
                    borderRadius: '4px',
                    padding: '6px',
                    fontSize: '14px',
                    cursor: 'pointer' 
                  }}
                >
                  USD
                </div>
            </div>
            <div className={`myBtn w-100 text-center mt-3 ${disable?'disabled':null}`} style={{paddingTop: '12px',paddingBottom: '12px'}} onClick={!disable ? AddSignal : null}>{loading?<FontAwesomeIcon icon={faCircleNotch} style={{fontSize: '20px', color: 'white', opacity: '0.5'}} spin />:'Add'}</div>
        </Modal>
      </div>
    </div>
  )
}

export default Signal